/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEditorialRequest} from '@cash-web/protos/squareup/cash/local/client/v1/local_editorial.pb'
import {GetEditorialResponse} from '@cash-web/protos/squareup/cash/local/client/v1/local_editorial.pb'


export const getEditorial = (request:GetEditorialRequest, options?: CashRequestOptions) => post<GetEditorialRequest, GetEditorialResponse>("/2.0/cash/get-editorial", request, {...options, rejectOnError: true })